<div class="heading">{{title}}</div>

<div [fxLayout]="fxDirection" fxLayout.lt-lg="column" fxLayoutGap="20px" fxLayoutAlign="fxAlignment">

  <div *ngFor="let entity of items" class="item" fxFlex="flexValue" [ngClass]="direction" (click)="goToItem(entity)"
    style="cursor: pointer;">

    <!-- image -->
    <div class="image" [style.background-image]="entity.mainImage.safe" *ngIf="entity.mainImage">
    </div>

    <div class="content">

      <div class="title">
        <span>{{entity.title}}</span>
      </div>

      <div class="teaser">
        {{entity.teaser}}
      </div>

      <div fxLayout="row" fxLayoutAlign="end center">
        <button class="transparent-orange-button">Weiterlesen</button>
      </div>
    </div>

  </div>
</div>